import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const getChargeCardEligibility = gql`
  query GetChargeCardEligibility {
    chargeCardEligibility {
      __typename
      ... on ChargeCardEligibilitySuccess {
        id
      }
      ... on ChargeCardNotQualified {
        id
        title
      }
      ... on ChargeCardEligibilityError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default getChargeCardEligibility;
